// src/service/reserve.js
import request from '../../../common/request/index.js'
const api = request.api

export default {
  page: (params) => {
    return api.post('reserve/reserve/page', params)
  },
  manual: (data) => {
    return api.post('reserve/reserve/manual', data)
  },
  getStationBalance: (stationId) => {
    return api.get(`reserve/reserve/station/${stationId}`)
  },
  // ===== 新增导出方法 =====
  export: (params) => {
    return api.post('reserve/reserve/export', params, { responseType: 'blob' })
  }
}